import { Extension } from '@tiptap/core';

/* Docs — one consistent escape hatch out of every "container" block.
 *
 * StarterKit's code block already exits on Shift-Enter; the callout got the same
 * treatment when Anthony found it inescapable. Blockquote had neither, so the
 * behaviour was arbitrary: three container blocks, three different answers.
 *
 * This centralises the rule — Shift-Enter in ANY wrapping block inserts a fresh
 * paragraph after it and puts the cursor there. Returns false when the cursor is
 * not in one, so the ordinary hard-break behaviour is untouched everywhere else.
 *
 * Registered AFTER the container extensions so it wins the keymap; Callout keeps
 * its own handler for the same combo, which is harmless — whichever runs first
 * performs the identical exit and returns true.
 */

const EXITABLE = ['blockquote', 'callout'];

const BlockExits = Extension.create({
	name: 'blockExits',

	addKeyboardShortcuts() {
		const exit = ({ editor }) => {
			const { $from } = editor.state.selection;
			// Walk out from the cursor looking for the nearest exitable ancestor.
			for (let depth = $from.depth; depth > 0; depth -= 1) {
				if (EXITABLE.includes($from.node(depth).type.name)) {
					const after = $from.after(depth);
					return editor
						.chain()
						.insertContentAt(after, { type: 'paragraph' })
						.setTextSelection(after + 1)
						.focus()
						.run();
				}
			}
			return false;
		};

		return {
			'Shift-Enter': exit,
			// Cmd/Ctrl-Enter is the other muscle-memory escape; same behaviour.
			'Mod-Enter': exit,
		};
	},
});

export default BlockExits;
